/* global AG_FEATURES */
/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import 'magnific-popup';

import fullpage from 'fullpage.js/dist/fullpage.extensions.min';

/**
 * Theme supports dependent imports
 * Don't forget to remove the import and the function call if a theme support is not used, this will reduce the bundle size
 */
import pageTransition from './theme-support/pageTransition';
import locomotiveScroll from './theme-support/locomotiveScroll';
import headroom from './theme-support/headroom';

/**
 * Internal dependencies
 */
import offcanvas from './util/offcanvas';
import lazyGmap from './util/lazyGmap';
import initWpBlockGalleryMagnificPopup from './util/initWpBlockGalleryMagnificPopup';
import initScroller from './util/scroller';
import initAccordion from './util/accordion';
import {
  prepare as animationPrepare,
  run as animationRun,
} from './util/animation';
import acfBlocks from './acf-blocks';
import heroHeader from './util/heroHeader';

const $body = $(document.body);
let fullpageInstance = null;

// Since barba.js maybe used if the page transition are enabled (theme support)
// we need to split the code into different parts
const handler = {
  // the code that must be only run once (initial page load)
  runOnce: () => {
    offcanvas.runOnce();


    $body.trigger('runOnce.ag.handler');
  },
  leave: () => {
    if (fullpageInstance) {
      fullpageInstance.destroy('all');
      fullpageInstance = null;
    }
  },
  // the code that must be run everytime when the new content is ready but the page transition is still shown
  beforeRun: () => {
    offcanvas.beforeRun();
    animationPrepare();
    lazyGmap();
    initWpBlockGalleryMagnificPopup();
    initAccordion();
    initScroller();
    acfBlocks();
    heroHeader();

    const $banner = $('header.banner');

    fullpageInstance = new fullpage('main', {
      licenseKey: 'LNK66-2RNC7-K0886-940J9-WUXUP',
      credits: {
        enabled: false,
      },
      scrollBar: true,
      autoScrolling: true,
      navigation: true,
      responsiveHeight: 1080,
      afterRender: function () {
        fullpage_api.silentMoveTo(1);
        $('.ag-hero-header__carousel').trigger('refresh.owl.carousel');
      },
      // beforeLeave: (origin, destination, direction, trigger) => {
      //   if (direction === 'up') {
      //     const $toAnimate = $(destination.item).find('.ag-animate').not('[data-ag-animation]');
      //     if ($toAnimate.length) {
      //       $toAnimate.data('agAnimation', 'fadeInUp');
      //     }
      //   }
      // },
      onLeave: (origin, destination, direction, trigger) => {
        if (destination.index === 0) {
          $banner.addClass('headroom--top');
        } else {
          $banner.removeClass('headroom--top');
        }

        if (direction === 'up') {
          $banner.removeClass('headroom--unpinned').addClass('headroom--pinned');
        } else {
          $banner.removeClass('headroom--pinned').addClass('headroom--unpinned');
        }
      },
      afterLoad: (origin, destination, direction, trigger) => {
        if ($(destination.item).hasClass('fp-auto-height')) {
          return;
        }

        // const $toHide = $(origin.item).find('.ag-animate');
        // if ($toHide.length) {
        //   $toHide.css('opacity', 0);
        // }
      },
    });

    const $ctnAxio = $('#ctn-axio');
    const $ctnAxioBuilding = $ctnAxio.find('.building');
    const $ctnOffersContainer = $('#ctn-building-offers');
    const $ctnAxioOffers = $ctnOffersContainer.children();
    const $noOffers = $ctnOffersContainer.children('#ctn-building-offers-not-available');
    const availableBuildings = $ctnAxioOffers.map((i, e) => $(e).data('building')).toArray();

    if ($ctnAxio.length) {
      $ctnAxioBuilding.hover(
          (e) => {
            const $target = $(e.currentTarget);
            if ($target.hasClass('active')) {
              return;
            }

            const fill = availableBuildings.includes(parseInt($target.data('building'))) ? '#FFD131' : '#ababab';
            $(e.currentTarget).children('.filler').css({ fill });
          },
          (e) => {
            const $target = $(e.currentTarget);
            if ($target.hasClass('active')) {
              return;
            }

            $target.children('.filler').css({ fill: ''});
          }
      );

      $ctnAxioBuilding.on('click', (e) => {
        const $target = $(e.currentTarget);
        const buildingNumber = $target.data('building');
        $ctnAxioOffers.hide();

        const $toShow = $ctnAxioOffers.filter(`[data-building="${buildingNumber}"]`);
        if ($toShow.length) {
          $toShow.show();
        } else {
          $noOffers.find('span').text(buildingNumber);
          $noOffers.show();
        }

        const fill = availableBuildings.includes(parseInt($target.data('building'))) ? '#FFD131' : '#ababab';
        $ctnAxioBuilding.removeClass('active').children('.filler').css('fill', '');
        $target.addClass('active').children('.filler').css('fill', fill);
      });
    }

    const $realEstateCarousel = $('#real-estate-carousel');
    if ($realEstateCarousel.length) {
      $realEstateCarousel.owlCarousel({
        autoplay: true,
        rewind: true,
        dots: true,
        margin: 20,
        responsive: {
          0: {
            items: 1,
          },
          768: {
            items: 2,
          },
          992: {
            items: 3,
          },
        },
      });

      $realEstateCarousel.magnificPopup({
        delegate: 'a.item__image-full',
        type: 'image',
        gallery: {
          enabled: true,
        },
      });
    }

    const $relatedOffersCarousel = $('#related-offers-carousel');
    if ($relatedOffersCarousel.length) {
      $relatedOffersCarousel.owlCarousel({
        autoplay: true,
        loop: true,
        margin: 20,
        responsive: {
          0: {
            items: 1,
          },
          768: {
            items: 2,
          },
          992: {
            items: 3,
          },
        },
      });
    }

    $('[data-toggle="tooltip"]').tooltip();

    $body.trigger('beforeRun.ag.handler');
  },
  // the code that must be run everytime when the page transition is completed
  run: () => {
    animationRun();

    $body.trigger('run.ag.handler');
  },
  runAll: () => {
    handler.runOnce();
    handler.beforeRun();
    handler.run();
  },
};

$(document).ready(() => {
  if (AG_FEATURES.headroom === true) {
    headroom();
  }

  handler.runAll();

  if (AG_FEATURES.locomotiveScroll === true) {
    locomotiveScroll();
  }

  if (AG_FEATURES.pageTransition === true) {
    pageTransition(handler);
  }
});
